import { render } from "./Beliefs.vue?vue&type=template&id=3c8043c9"
import script from "./Beliefs.vue?vue&type=script&lang=js"
export * from "./Beliefs.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__